export const pillars = ['Hormone Blueprint', 'Metabolic Cooling', 'Circadian Repair', "COGNITIVE SHIELD", "VITAL MOTION", 'Revival Roadmap'];
export const volumes = [{
  n: 1,
  emoji: '📘',
  title: 'The Hormone Blueprint',
  desc: 'Understand the scientific foundation of your shifting body clearly and step by step, so you can eliminate all guilt and confusion — even if you feel completely lost right now.'
}, {
  n: 2,
  emoji: '📗',
  title: 'Metabolic Cooling Protocols',
  desc: 'Learn how to reduce hot flashes and systemic inflammation naturally, incorporating the specific "Meno-Safe" foods that calm your internal thermostat down.'
}, {
  n: 3,
  emoji: '📙',
  title: 'Circadian Repair & Night Sleep System',
  desc: 'Master advanced protocols designed to eliminate night sweats, midnight anxiety, and chronic insomnia so you can wake up refreshed and deeply restored.'
}, {
  n: 4,
  emoji: '📕',
  title: 'The Cognitive Shield Framework',
  desc: 'Follow an organized framework to banish brain fog, reclaim your sharp mental clarity, and manage mood swings with clear criteria to regain total emotional stability.'
}, {
  n: 5,
  emoji: '📓',
  title: 'Vital Motion & Low-Impact Fitness',
  desc: 'Incorporate short, gentle, and highly effective movement routines that protect your bone density and boost your metabolism without triggering high stress or cortisol spikes.'
}, {
  n: 6,
  emoji: '📔',
  title: 'The Revival Roadmap & 30-Day Plan',
  desc: 'Put the entire protocol into immediate action with an easy-to-follow daily checklist, tracking your journey effortlessly from day 1 to day 30.'
}];
export const volumeIncludes = ['Visual step-by-step natural protocols', 'Symptom management criteria + checklists', 'Hormonal progression checkpoints', 'Real lifestyle adaptation examples', 'Daily self-care workflows', 'Printable tracking sheets', 'Designed specifically for women over 40', 'Ready to apply from tonight'];
export const bonuses = [{
  n: '01',
  title: 'The Hormone-Balancing Elixirs 🍹',
  desc: 'Stop starving or guessing. Get 25 quick, delicious, and premium smoothie recipes specifically formulated to kill sugar cravings, reduce bloat, and balance your hormones on busy mornings.',
  price: '$27',
  cover: 'https://cdn.magicpatterns.com/uploads/eUT1HLT6rTjhCoz1nBkXai/ChatGPT_Image_13_sept_2026,_12_21_34.png'
}, {
  n: '02',
  title: 'The 7-Day Meno-Detox 🥗',
  desc: 'Kickstart your transformation. A fully structured anti-inflammatory meal plan with clear tables and grocery lists designed to dramatically reduce gut bloat and flush out metabolic waste in your very first week.',
  price: '$29',
  cover: 'https://cdn.magicpatterns.com/uploads/nyXscWvSAMqkUQfwzGJByB/ChatGPT_Image_13_sept_2026,_12_21_36.png'
}, {
  n: '03',
  title: 'The Meno-Apothecary 🧪',
  desc: 'Your ultimate reference encyclopedia. A science-backed guide to natural herbs, vitamins, and minerals. Know exactly what to take for each specific symptom, the precise safety dosages, and which popular brands you must avoid.',
  price: '$37',
  cover: 'https://cdn.magicpatterns.com/uploads/sdywPpsND8Y4S6QGZBUeTp/ChatGPT_Image_13_sept_2026,_12_21_39.png'
}];